export enum ResourceName {
  Organization = "Organization",
  Practitioner = "Practitioner",
  Patient = "Patient",
  Location = "Location",
  Device = "Device",
  Invitation = "Invitation",
  Procedure = "Procedure",
  Analytics = "Analytics",
  Learning = "Learning",
  LearningGrant = "LearningGrant",
  OrganizationBilling = "OrganizationBilling",
  LearningAssignment = "LearningAssignment",
  LearningProgress = "LearningProgress",
  SalesforceDashboard = "SalesforceDashboard",
  SalesforceReports = "SalesforceReports",
  Crm = "Crm",
  CrmDuplicateReview = "CrmDuplicateReview",
  SalesforceIntegration = "SalesforceIntegration",
  Staff = "Staff",
  Marketing = "Marketing",
  MarketingDelivery = "MarketingDelivery",
  FinanceNotifications = "FinanceNotifications",
  FinanceNotificationHandling = "FinanceNotificationHandling",
  FinanceNotificationBadge = "FinanceNotificationBadge",
  BillwerkCustomerMatch = "BillwerkCustomerMatch",
  BillwerkPlanVariants = "BillwerkPlanVariants",
  FinanceOverview = "FinanceOverview",
  LogisticsReports = "LogisticsReports",
  LogisticsDhlShippingSettings = "LogisticsDhlShippingSettings",
  LogisticsDhlAccountSettings = "LogisticsDhlAccountSettings",
  LogisticsDhlSettings = "LogisticsDhlSettings",
  LogisticsInventory = "LogisticsInventory",
  Integrations = "integrations",
}

// Embedded-only list resource: never registered as a permission-gated <Resource> route.
export const DEVICE_ENROLLMENT_TOKENS_RESOURCE = "DeviceEnrollmentTokens";

export const TEST_CUSTOMERS_RESOURCE = "TestCustomers";

// Web orders: Marketing follows them, Customer Service repairs a stuck one.
export const WEB_ORDERS_RESOURCE = "WebOrders";

// The portal phone: shown in the header, never a registered <Resource> route.
export const TELEPHONY_RESOURCE = "Telephony";

// Facilities list: served by the dedicated Customer Service query, never a registered <Resource> route.
export const CUSTOMER_SERVICE_ORGANIZATIONS_RESOURCE = "CustomerServiceOrganizations";

export const SALESFORCE_DASHBOARD_ROUTE = "/salesforce-dashboard";
export const SALESFORCE_REPORTS_ROUTE = "/salesforce-reports";
export const SALESFORCE_RECORDS_ROUTE = "/salesforce-records";
export const SALESFORCE_INTEGRATION_ROUTE = "/salesforce-integration";
export const MARKETING_DELIVERY_ROUTE = "/marketing-delivery";
export const TEAM_ROUTE = "/team";
export const INTEGRATIONS_ROUTE = "/integrations";
export const FINANCE_NOTIFICATIONS_ROUTE = "/finance/notifications";
export const BILLWERK_CUSTOMER_MATCH_ROUTE = "/finance/customer-match";
export const BILLWERK_PLAN_VARIANTS_ROUTE = "/finance/plan-variants";
export const FINANCE_OVERVIEW_ROUTE = "/finance/overview";
export const LOGISTICS_ROUTE = "/logistics";
export const LOGISTICS_REPORTS_ROUTE = `${LOGISTICS_ROUTE}/reports`;
export const LOGISTICS_INVENTORY_ROUTE = "/logistics/inventory";
export const LOGISTICS_INVENTORY_MDM_ROUTE = `${LOGISTICS_INVENTORY_ROUTE}?type=Tablet&deviceFilter=WORKSPACE_ONE`;
export const LOGISTICS_INVENTORY_ITEM_ROUTE = `${LOGISTICS_INVENTORY_ROUTE}/:id`;

export const LOGISTICS_WORKSPACE_ONE_ROUTE = "/logistics/workspace-one";

export const LOGISTICS_DHL_SETTINGS_ROUTE = `${LOGISTICS_ROUTE}/dhl-settings`;
